import React, {useCallback, useMemo} from 'react';

import {Button, useMobile, useThemeValue} from '@gravity-ui/uikit';
import type {PageContent} from '@gravity-ui/page-constructor';

import {crossReachGoal} from '~ui/services/metrika';

import {getLogoUrl} from '~ui/utils';

import {PromoPageListItem} from '../PromoPageListItem';
import {SIGN_IN_GOAL} from '../constants';

import {i18n} from '../i18n';

import {getAnchors} from './helpers/getAnchors';

import {cnPromoPageHeader} from './PromoPageHeader.classname';
import './PromoPageHeader.scss';
interface PromoPageHeaderProps {
    content: PageContent;
}

export const PromoPageHeader: React.FC<PromoPageHeaderProps> = ({content}) => {
    const [isMobile] = useMobile();
    const theme = useThemeValue();

    const anchors = useMemo(() => getAnchors(content), [content]);

    const handleClick = useCallback(() => {
        crossReachGoal(SIGN_IN_GOAL);
    }, []);

    return (
        <div className={cnPromoPageHeader()}>
            <div className={cnPromoPageHeader('Container')}>
                <div className={cnPromoPageHeader('LeftSide')}>
                    <div className={cnPromoPageHeader('IconWrap')}>
                        <img src={getLogoUrl('Yandex Wiki', theme)} />
                    </div>
                    <div>
                        {!isMobile && (
                            <ul className={cnPromoPageHeader('List')}>
                                {anchors.map((anchor, index) => (
                                    <PromoPageListItem
                                        href={anchor.href}
                                        className={cnPromoPageHeader('Link')}
                                        text={anchor.text}
                                        key={index}
                                    />
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
                {!isMobile && (
                    <Button
                        view="action"
                        size="l"
                        href="/?skipPromo=1"
                        target="_self"
                        onClick={handleClick}
                    >
                        {i18n('login-button-label')}
                    </Button>
                )}
            </div>
        </div>
    );
};
